import { WorkflowDiagramConnectionStepDivider } from './WorkflowDiagramConnectionStepDivider';
import styles from './WorkflowDiagramConnectionStep.module.css';

type WorkflowDiagramConnectionStepProps = {
  title: string;
};

export const WorkflowDiagramConnectionStep = ({ title }: WorkflowDiagramConnectionStepProps) => {
  return (
    <div className={styles.workflowDiagramConnectionStepRoot}>
      <WorkflowDiagramConnectionStepDivider />
      <div className={styles.workflowDiagramConnectionStepPill}>
        <span className={styles.workFlowDiagramConnectionStepPillText}>{title}</span>
      </div>
    </div>
  );
};
